import { TicketInfo } from "./ticket";

export type SaleQuestionnaire = {
    PackageID: number;
    EventID: number;
    EventDateID: number;
    TicketsIDs: number[];
    HaveUnfilledQuestionnaire: boolean;
    ModelID: string;
    IsReadonly: boolean;
    ParentModelID: string;
    ParentPropertyName: string;
    ListName: string;
    IsNewModel: boolean;
    SelfCheckForModificaiton: boolean;
}


export type UnfilledQuestionnaireResult = {
    SaleQuestionnaireIDs: string[];
    TicketInfos: TicketInfo[];
}